/**
 * 通用确认弹窗 — 连接到 toastStore，全局单例模式
 *
 * 不在 props 传参，而是从 useToastStore 读取 confirmState。
 * 调用方使用 confirm() 函数（返回 Promise<boolean>）。
 */
import React from 'react';
import { useToastStore } from '../store/toastStore';

const ConfirmDialog: React.FC = () => {
  const { isOpen, title, message, confirmLabel, cancelLabel, danger, resolve } =
    useToastStore((s) => s.confirmState);
  const resolveConfirm = useToastStore((s) => s._resolveConfirm);

  if (!isOpen) return null;

  const handleConfirm = () => resolveConfirm(true);
  const handleCancel = () => resolveConfirm(false);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="fixed inset-0 bg-black/40 backdrop-blur-sm" onClick={handleCancel} />
      <div className="relative card shadow-modal rounded-xl max-w-md w-full mx-4 p-6">
        <h3 className="text-lg font-semibold text-slate-900 mb-2">{title}</h3>
        <p className="text-sm text-slate-600 mb-6 whitespace-pre-wrap">{message}</p>
        <div className="flex justify-end gap-3">
          <button
            onClick={handleCancel}
            className="btn-secondary"
          >
            {cancelLabel}
          </button>
          <button
            onClick={handleConfirm}
            className={danger ? 'bg-red-600 hover:bg-red-700 text-white px-4 py-2 text-sm font-medium rounded-md' : 'btn-primary'}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDialog;
